import styled from 'styled-components';

export const Div = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 10px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.auth.lightPurple};
  margin-bottom: 26px;
`;

export const Title = styled.h5`
  font-size: ${({ theme }) => theme.fontsizes.h5};
  font-weight: ${({ theme }) => theme.fontWeight.font700};
  color: ${({ theme }) => theme.colors.black2};
`;
